import { render, staticRenderFns } from "./CustomAttributeSelector.vue?vue&type=template&id=48f0c2e0&scoped=true&"
import script from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeSelector.vue?vue&type=style&index=0&id=48f0c2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f0c2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f0c2e0')) {
      api.createRecord('48f0c2e0', component.options)
    } else {
      api.reload('48f0c2e0', component.options)
    }
    module.hot.accept("./CustomAttributeSelector.vue?vue&type=template&id=48f0c2e0&scoped=true&", function () {
      api.rerender('48f0c2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/customAttributes/CustomAttributeSelector.vue"
export default component.exports